import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Websites from './websites/Websites';
import Documents from './documentation/Documents';
import Questions from './questions/Questions';
import TaskDefinitions from './taskDefinitions/TaskDefinitions';
import KnowledgeNavBar from './KnowledgeNavBar';

const Knowledge = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'websites';
  const [activeTab, setActiveTab] = useState(initialTab);

  // Ensure the active tab is one of the valid values
  useEffect(() => {
    if (!['websites', 'documents', 'questions', 'task-definitions'].includes(initialTab)) {
      setActiveTab('websites');
      setSearchParams({ tab: 'websites' });
    }
  }, [initialTab, setSearchParams]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* Sidebar navigation */}
      <KnowledgeNavBar activeTab={activeTab} handleTabChange={handleTabChange} />

      {/* Content area */}
      <div className="flex-1 h-full overflow-auto">
        {activeTab === 'websites' && <Websites />}
        {activeTab === 'documents' && <Documents />}
        {activeTab === 'questions' && <Questions />}
        {activeTab === 'task-definitions' && <TaskDefinitions />}
      </div>
    </div>
  );
};

export default Knowledge;
